export function calculateMonthlyPayment(loanAmount, loanMonths) {
  const annualInterestRate = 0.06;
  const monthlyInterestRate = annualInterestRate / 12;
  const payment =
    (loanAmount * monthlyInterestRate) /
    (1 - Math.pow(1 + monthlyInterestRate, -loanMonths));
  return payment.toFixed(2);
}

export const LOAN_AMOUNT_DEFAULT = 50000;
export const LOAN_AMOUNT_MIN = 1000;
export const LOAN_AMOUNT_MAX = 500000;
export const LOAN_AMOUNT_STEP = 1000;
export const LOAN_DURATION_DEFAULT = 12;
export const LOAN_DURATION_MIN = 6;
export const LOAN_DURATION_MAX = 60;
export const LOAN_DURATION_STEP = 1;

export const FACTORING_AMOUNT_DEFAULT = 50000;
export const FACTORING_AMOUNT_MIN = 1000;
export const FACTORING_AMOUNT_MAX = 500000;
export const FACTORING_AMOUNT_STEP = 1000;
